import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import ComponenteError from '../publicaciones/ComponenteError'
import Publicacion from '../publicaciones/Publicacion'
import * as favoritosService from '../servicios/favoritosService'
import styles from './Favoritos.module.css'

const Favoritos = () => {
  const [favoritos, setFavoritos] = useState([])
  const navigate = useNavigate()
  const { loginDataContext: { idUsuario } = {} } = useAuth()

  useEffect(() => {
    const fetchFavoritos = async () => {
      const userId = idUsuario
      if (!userId) return

      const { data: favoritos } = await favoritosService.buscarPorUsuario(userId)
      setFavoritos(favoritos.filter((fav) => fav.idVendedor !== parseInt(userId)))
    }

    fetchFavoritos()
  }, [idUsuario])

  const handleToggle = (event, favorito, idPublicacion) => {
    navigate(`/Publicacion/${idPublicacion}`)
  }

  const updateFavoritos = async (idpub) => {
    setFavoritos((prev) => prev.filter((pub) => pub.idPublicacion !== idpub))
  }

  return (
    <fieldset className={styles.fieldset}>
      <legend>Mis Favoritos</legend>
      <div className={styles.grid}>
        {favoritos.length > 0 ? (
          favoritos.map((publicacion) => (
            <Publicacion
              key={publicacion.idPublicacion}
              onToggleClick={handleToggle}
              publicacion={publicacion}
              compFavorito={true}
              onDelete={updateFavoritos}
            />
          ))
        ) : (
          <div className={styles.vacio}>
            <ComponenteError tipo="i" idAviso={5} />
          </div>
        )}
      </div>
    </fieldset>
  )
}

export default Favoritos
